// M4 workstream C (world): deepwater & megaprojects (§10), the Macondo regime (§11), politics & sanctions (§12),
// oil sands (§15), news/achievement state (§16). Hook contract: src/sim/m4/index.js. Everything is inert before
// 1 Jan 2000 (m4On) and creates its state (state.m4w) lazily, so M1–M3 games are byte-identical.
import { dayToDate } from '../../core/time.js';
import { LEASE_ROUNDS_M4 } from '../../data/m4/rules.js';
import { m4On } from './worldCore.js';
import { tickSpudCosts, tickMoratoriumNotices, tickDeepwaterBlowouts, chargeRegimeFees } from './worldRegime.js';
import { tickWellMults } from './worldDeep.js';
import { tickStormsM4, tickSanctionNotices, tickNationalizationsM4, tickPesos, openLeaseRoundM4, tickOccupationsM4 } from './worldPolitics.js';
import { tickMegaprojectsM4 } from './worldMega.js';
import { tickOilSands, chargeTailingsFines } from './worldOilSands.js';

// Before drilling: named storms (warning lead) so today's sea state and evacuations apply.
export function tickPre(state) {
  if (!m4On(state)) return;
  tickStormsM4(state);
}

// After production: compliance cost at spud, subsea/CO₂ qi multipliers, the oil-sands loops, deepwater blowouts.
export function tickPost(state) {
  if (!m4On(state)) return;
  tickSpudCosts(state);
  tickWellMults(state);
  tickOilSands(state);
  tickDeepwaterBlowouts(state);
}

// End of day: regime/sanction notices, nationalizations, megaprojects, lease rounds by date, monthly fees & fines.
export function tickEcon(state) {
  if (!m4On(state)) return;
  tickMoratoriumNotices(state);
  tickSanctionNotices(state);
  tickNationalizationsM4(state);
  tickOccupationsM4(state);
  tickMegaprojectsM4(state);
  for (const r of LEASE_ROUNDS_M4) if (r.day === state.day && !state.rounds?.[r.id]) openLeaseRoundM4(state, r.id);
  if (dayToDate(state.day).dom === 1) {
    chargeRegimeFees(state);
    tickPesos(state);
    chargeTailingsFines(state);
  }
}
